import setBreakpoint from './setBreakpoint.js';
import getBreakpoint from './getBreakpoint.js';
export default {
  setBreakpoint,
  getBreakpoint
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/core/breakpoints/index.js
// module id = 697
// module chunks = 0 1